import type { SaveData } from '@/domains/onboarding/types';

export const OnboardingApiService = Symbol('OnboardingApiService');

export interface OnboardingApiService {
    save(data: SaveData): Promise<boolean>;
    info(): Promise<SaveData>;
}
